import { render, staticRenderFns } from "./ExpensePermissionIndex.vue?vue&type=template&id=e13ca630&"
import script from "./ExpensePermissionIndex.vue?vue&type=script&lang=js&"
export * from "./ExpensePermissionIndex.vue?vue&type=script&lang=js&"
import style0 from "./ExpensePermissionIndex.vue?vue&type=style&index=0&id=e13ca630&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports